module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-92f60205.png";